// import snakeCase from "lodash.snakecase";

interface MultiSelectItem {
   text: string;
   value: string;
}
type MultiSelectArray = MultiSelectItem[];

//TODO: Rename this to useDynamicOptions
export async function useMultiSelectData(
   dynamicOption: "topics" | "curriculum",
): Promise<MultiSelectArray | undefined | { message: string; status: number }> {
   // helpers
   const $apiFetch = useNuxtApp().$apiFetch as typeof $fetch;
   const route = useRoute();
   const { log, logError } = useDebugger();

   try {
      let multiSelectItems: Array<{
         text: string;
         value: string;
      }>;
      switch (dynamicOption) {
         case "topics":
            {
               // discipline
               const discipline_id = disciplineId(route.params.discipline);
               if (!discipline_id) return undefined;

               const data = await $apiFetch<{
                  categories: Array<{ category: string }>;
               }>("categories/group", {
                  params: { key: "activity", discipline_id: discipline_id },
               });
               multiSelectItems = data.categories.map(
                  (item): MultiSelectItem => ({
                     text: item.category,
                     value: item.category,
                  }),
               );
            }
            break;
         case "curriculum":
            {
               const data = await $apiFetch<string[]>("standards/curriculum");
               multiSelectItems = data.map(
                  (item: string): MultiSelectItem => ({
                     text: item,
                     value: item,
                  }),
               );
            }
            break;
      }

      return multiSelectItems;
   } catch (err) {
      logError("useMultiSelectData failed", err);
      return undefined;
   }
}
